import { Show } from "solid-js";
import * as styles from "./css/CurrentGun.module.css";
import { Subheading } from "@gui/components/texts";
import { playerState } from "@stores";
import CurrentGunImage from "./image";
import FiringModeManager from "./firing";
const CurrentGun = () => {
    return (<Show when={!!playerState() && playerState().gun}>
            <span class={styles.container}>
                <CurrentGunImage gunImageSource={playerState().gun.imageSource} gunName={playerState().gun.name}/>
                <section class={styles.gun_info}>
                    <header>
                        <Subheading>{playerState().gun.name}</Subheading>
                    </header>
                    <div>
                        <FiringModeManager />
                    </div>
                </section>
            </span>
        </Show>);
};
export default CurrentGun;
